import { hapticFeedback } from '@tma.js/sdk-react'
import { useEffect, useRef } from 'react'

export type ImpactStyle = 'light' | 'medium' | 'heavy'
export type NotificationType = 'success' | 'warning' | 'error'

/**
 * Вибрация — по карте Haptic из CLAUDE.md, а не на каждый тап.
 * Старый клиент без Haptic просто молчит.
 */
export const haptic = {
  impact: (style: ImpactStyle): void => {
    hapticFeedback.impactOccurred.ifAvailable(style)
  },
  notification: (type: NotificationType): void => {
    hapticFeedback.notificationOccurred.ifAvailable(type)
  },
  selection: (): void => {
    hapticFeedback.selectionChanged.ifAvailable()
  },
}

/** Уведомление один раз при показе экрана: отказные экраны, успех оплаты. */
export const useNotificationOnce = (type: NotificationType | null): void => {
  const fired = useRef(false)

  useEffect(() => {
    if (type && !fired.current) {
      fired.current = true
      haptic.notification(type)
    }
  }, [type])
}
